"use client";

import React, { useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { RenderCategories } from "@components/RenderCategories";
import { logErrorToAPI } from "src/utils/errorLogger";

const AlgoliaSearch = dynamic(() => import("../AlgoliaSearch/AlgoliaSearch"), {
  ssr: false,
});

const Error500 = ({ error }) => {
  useEffect(() => {
    // Log ONLY server/runtime errors (500)
    if (error && Object.keys(error).length > 0) {
      logErrorToAPI(error, {
        type: "server-error",
        errorId: Date.now().toString(),
      });
    }
  }, [error]);

  return (
    <>
      <div className="errorPageContainer topPadding">
        <div className="width-100 horizontal">
          <h1 className="oppsHead">Oops!</h1>
        </div>

        <div className="search">
          <span>Try Again</span>
          <AlgoliaSearch classes="errorSearchBox" />
        </div>

        <div className="width-100 bookCategory">
          <RenderCategories />
          <div className="bookContainer">
            <img src={`${process.env.S3_IMAGE_URL}/book.png`} className="bookImage" alt="error" />
          </div>

          <p>
            Back to <Link href="/">Home</Link>
          </p>
        </div>
      </div>

      <style>
        {`
          .errorPageContainer {
            width: 50%;
            margin: 1rem;
            overflow: hidden;
          }
          .width-100 {
            display: flex;
            flex-wrap: wrap;
          }
          .width-100.horizontal {
            flex-direction: column;
            text-align: center;
          }
          .width-100.bookCategory {
            justify-content: space-between;
          }
          .width-100.bookCategory .bookContainer,
          .width-100.bookCategory .listContainer {
            flex: 0 0 100%;
            max-width: calc(40% - 10px);
          }
          .width-100.bookCategory .listContainer {
            max-width: calc(60% - 10px);
          }
          .subHeading {
            margin-top: 0px;
            font-size: 16pt;
          }
          .oppsHead {
            font-size: 8rem;
            margin: 15px auto;
          }
          .bookImage {
            width: 90%;
          }
          @media (max-width: 1024px) {
            .errorPageContainer {
              width: 80%;
            }
          }
          @media (max-width: 768px) {
            .errorPageContainer {
              width: 100%;
            }
          }
          @media (max-width: 575px) {
            .width-100 {
              flex-direction: column;
              margin-top: 20px;
            }
            .width-100.bookCategory .bookContainer,
            .width-100.bookCategory .listContainer {
              max-width: 100%;
            }
            .oppsHead {
              font-size: 4rem;
            }
          }
          .errorSearchBox {
            margin: 10px 0;
            width: 90%;
          }
        `}
      </style>
    </>
  );
};

Error500.Layout = SingleColumnLayout;
Error500.displayName = "Error500";

export default Error500;
